import { render, staticRenderFns } from "./ContestTabs.vue?vue&type=template&id=10d2a39e"
import script from "./ContestTabs.vue?vue&type=script&lang=js"
export * from "./ContestTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports